import { useState } from "react";
import { useParams } from "next/navigation";
import Layout from "src/components/Layout";
import NavBarDoIt from "src/components/LiterasiKeuangan/NavbarDoItCerdas";
import NextHead from "src/components/Seo/NextHead";
import BreadcrumbComponent from "src/components/UserInterface/BreadcrumbComponent";
import { CaraCerdasMeta } from "src/data/DataMetatags";
import {
  CaraCerdasBreadcrumb,
  defBreadcrumb,
} from "../../../data/DataBreadcrumb";
import {
  CaraCerdasList,
  FinansialLiteracyListCategory,
} from "src/data/literasi-keuangan/CaraCerdasContent";
import CaraCerdasSidebar from "src/components/LiterasiKeuangan/CaraCerdas/CaraCerdasSidebar";
import SliderCaraCerdasMobile from "src/components/UserInterface/SliderCaraCerdasMobile";
import FinancialLiteracyList from "src/components/LiterasiKeuangan/CaraCerdas/FinancialLiteracyList";

const CaraCerdas = (props) => {
  const { breadcrumb, CaraCerdasBreadcrumb, title, description, path } = props;
  const params = useParams();
  const slug = params?.slug || "Rencana & Tujuan Financial";
  const [isLoadingList, setIsLoadingList] = useState(false);
  const content = CaraCerdasList.find((item) => item.slug === slug);

  return (
    <Layout>
      <NextHead
        title={title}
        description={description}
        url={path}
        breadcrumb={breadcrumb}
      />
      <NavBarDoIt></NavBarDoIt>
      <div className="CaraCerdas-wrapper">
        <CaraCerdasSidebar />
        <div className="CaraCerdas-body">
          <BreadcrumbComponent items={CaraCerdasBreadcrumb} />
          <div className="CaraCerdas-content">
            <h1 className="CaraCerdas-title">{content?.title}</h1>
            <p className="CaraCerdas-subtitle">{content?.subtitle}</p>
            {FinansialLiteracyListCategory.map((category, key) => {
              return (
                <div className="CaraCerdas-content-section" key={key}>
                  <h1 className="CaraCerdas-content-title">{category.name}</h1>
                  <div className="CaraCerdas-content-card-wrapper">
                    <FinancialLiteracyList
                      isLoadingList={isLoadingList}
                      setIsLoadingList={setIsLoadingList}
                      contentType={category.contentType}
                      slug={content?.slug}
                    />
                  </div>
                </div>
              );
            })}
            <div className="CaraCerdas-related-card-mobile">
              <h1 className="CaraCerdas-related-title">Cara Cerdas lainnya</h1>
              <SliderCaraCerdasMobile relatedTo={slug} />
            </div>
          </div>
        </div>
        <style jsx>{`
          .CaraCerdas-wrapper {
            display: flex;
            margin: 20px 60px;
            justify-content: center;
          }
          .CaraCerdas-body {
            width: 910px;
            margin-left: 10px;
          }
          .CaraCerdas-content {
            margin: 16px;
          }
          .CaraCerdas-title {
            font-size: 52px;
          }
          .CaraCerdas-subtitle {
            font-size: 20px;
            margin: 0px;
            margin-bottom: 48px;
          }
          .CaraCerdas-content-section {
            margin-bottom: 32px;
          }
          .CaraCerdas-content-card-wrapper {
            max-width: 940px;
            width: 100%;
            align-self: center;
            margin-top: 12px;
          }
          .CaraCerdas-related-card-mobile {
            display: none;
          }
          @media only screen and (max-width: 700px) {
            .CaraCerdas-wrapper {
              margin: 20px 0px;
            }
            .CaraCerdas-content {
              margin: 16px 10px;
            }
            .CaraCerdas-content-title {
              font-size: 20px;
            }
            .CaraCerdas-title {
              font-size: 24px;
            }
            .CaraCerdas-subtitle {
              font-size: 16px;
            }
            .CaraCerdas-related-card-mobile {
              display: block;
            }
            .CaraCerdas-related-title {
              margin: 16px 0px;
              font-size: 20px;
            }
          }
        `}</style>
      </div>
    </Layout>
  );
};

export async function getStaticPaths() {
  const paths = CaraCerdasList.map((item) => ({
    params: { slug: item.slug },
  }));

  return {
    paths,
    fallback: true,
  };
}

export const getStaticProps = async () => {
  const { title, description, path } = CaraCerdasMeta;
  const breadcrumb = [
    ...defBreadcrumb,
    {
      "@type": "ListItem",
      position: "2",
      item: {
        "@id": process.env.baseUrl + path,
        name: title,
      },
    },
  ];

  return {
    props: {
      breadcrumb,
      CaraCerdasBreadcrumb,
      title,
      description,
      path,
    },
  };
};

export default CaraCerdas;
